module.exports = __webpack_public_path__ + "img/pic5.eb9de249.png";